import lawyerRequestFA from './fa/fa.json'

const LawyerRequestMessages = {
  fa: { ...lawyerRequestFA },
}

export default LawyerRequestMessages
